import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import { Button, BtnType } from "../../../../primitives";
import styles from "./taskInfo.module.scss";
import { Icon, mdSize } from "../../../../../common/icon";
import { projectTaskAssigmentUpdate } from "../../companies/companies.action";

const TaskInfoHeaderComponent = (props) => {
  const {
    data: {
      company, stage, completed_on, assigned_to,
    },
    back,
    assignment,
    patientOrg,
    isProjectWideTask,
    handleComplete,
  } = props;
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isCompleted, setCompleted] = useState(false);

  useEffect(() => {
    setCompleted(completed_on);
  }, [completed_on]);

  const handleCompleteTaskClick = (value) => {
    handleComplete(value);
    setCompleted(value);
    dispatch(
      projectTaskAssigmentUpdate({
        assignmentId: assignment.id,
        completed: value,
        companyId: company && company.id,
        gskPatientOrganizationId: company && company.id,
        gsk: patientOrg,
        patient_org: patientOrg,
        assignedTo: assigned_to,
        stageId: stage,
        flag: value ? "completed_true" : "completed_false",
        enqueueSnackbar,
        isProjectWideTask,
      }),
    );
  };

  useEffect(() => {
    if (assignment) {
      setCompleted(completed_on);
    }
  }, [assignment?.id]);

  return (
    <div className={styles.headerWrp}>
      {back && (
        <div className={styles.back}>
          <Icon
            {...mdSize}
            icon="icn-right-chevron"
            className={styles.icon}
            onClick={back}
          />
        </div>
      )}
      <Button
        btn={isCompleted ? BtnType.REGULAR : BtnType.OUTLINE}
        onClick={() => handleCompleteTaskClick(!isCompleted)}
        icon={isCompleted ? "icn-checkbox-button" : "icn-checkbox-enabled"}
      >
        {isCompleted ? "completed" : "Mark task complete"}
      </Button>
    </div>
  );
};

export default React.memo(TaskInfoHeaderComponent);
